import { useQuery } from "@tanstack/react-query";
import { getFeatureConfig, getLocalFeatureConfig } from "./service";

export const useLocalFeatureConfigQuery = () =>
  useQuery({
    queryKey: ["featureFlags", "local"],
    queryFn: getLocalFeatureConfig,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

export const useFeatureConfigQuery = (enabled: boolean) =>
  useQuery({
    queryKey: ["featureFlags"],
    queryFn: getFeatureConfig,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled,
  });
